export default __webpack_public_path__ + "static/media/Ceiling-type-air-conditioner.15cebc77.jpg";